const ecoscanMockData = {
  lineChart: {
    overview: {
      transactionCount: [
        {
          date: "2024-12-31",
          yungtestworkspace3: 1479,
          jeff: 22,
          yungtestworkspace4: "N/A",
          yungtestworkspace5: "N/A",
          ethan: "-",
        },
        {
          date: "2025-01-01",
          yungtestworkspace3: 467,
          jeff: 12,
          yungtestworkspace4: "N/A",
          yungtestworkspace5: "N/A",
          ethan: "-",
        },
        {
          date: "2025-01-02",
          yungtestworkspace3: 96,
          jeff: 18,
          yungtestworkspace4: "N/A",
          yungtestworkspace5: "N/A",
          ethan: "-",
        },
        {
          date: "2025-01-03",
          yungtestworkspace3: 0,
          jeff: 0,
          yungtestworkspace4: "N/A",
          yungtestworkspace5: "N/A",
          ethan: "-",
        },
        {
          date: "2025-01-04",
          yungtestworkspace3: 0,
          jeff: 0,
          yungtestworkspace4: "N/A",
          yungtestworkspace5: "N/A",
          ethan: "-",
        },
        {
          date: "2025-01-05",
          yungtestworkspace3: 0,
          jeff: 0,
          yungtestworkspace4: "N/A",
          yungtestworkspace5: "N/A",
          ethan: "-",
        },
        {
          date: "2025-01-06",
          yungtestworkspace3: 0,
          jeff: 0,
          yungtestworkspace4: "N/A",
          yungtestworkspace5: "N/A",
          ethan: "-",
        },
      ],
    },
    community: {
      newDiscordMember: [
        {
          date: "2024-12-08",
          yungtestworkspace4: 46,
          yungtestworkspace5: 40,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-09",
          yungtestworkspace4: 35,
          yungtestworkspace5: 27,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-10",
          yungtestworkspace4: 14,
          yungtestworkspace5: 31,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-11",
          yungtestworkspace4: 23,
          yungtestworkspace5: 49,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-12",
          yungtestworkspace4: 48,
          yungtestworkspace5: 20,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-13",
          yungtestworkspace4: 45,
          yungtestworkspace5: 23,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-14",
          yungtestworkspace4: 21,
          yungtestworkspace5: 26,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-15",
          yungtestworkspace4: 45,
          yungtestworkspace5: 40,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-16",
          yungtestworkspace4: 27,
          yungtestworkspace5: 32,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-17",
          yungtestworkspace4: 10,
          yungtestworkspace5: 16,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-18",
          yungtestworkspace4: 37,
          yungtestworkspace5: 21,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-19",
          yungtestworkspace4: 42,
          yungtestworkspace5: 39,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-20",
          yungtestworkspace4: 22,
          yungtestworkspace5: 24,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-21",
          yungtestworkspace4: 27,
          yungtestworkspace5: 31,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-22",
          yungtestworkspace4: 29,
          yungtestworkspace5: 28,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-23",
          yungtestworkspace4: 13,
          yungtestworkspace5: 34,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-24",
          yungtestworkspace4: 24,
          yungtestworkspace5: 10,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-25",
          yungtestworkspace4: 45,
          yungtestworkspace5: 29,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-26",
          yungtestworkspace4: 16,
          yungtestworkspace5: 14,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-27",
          yungtestworkspace4: 22,
          yungtestworkspace5: 43,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-28",
          yungtestworkspace4: 50,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-29",
          yungtestworkspace4: 21,
          yungtestworkspace5: 41,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-30",
          yungtestworkspace4: 15,
          yungtestworkspace5: 12,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-31",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2025-01-01",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2025-01-02",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2025-01-03",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2025-01-04",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2025-01-05",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2025-01-06",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
      ],
      newTelegramMember: [
        {
          date: "2024-12-08",
          yungtestworkspace4: 47,
          yungtestworkspace5: 23,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-09",
          yungtestworkspace4: 10,
          yungtestworkspace5: 32,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-10",
          yungtestworkspace4: 28,
          yungtestworkspace5: 27,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-11",
          yungtestworkspace4: 25,
          yungtestworkspace5: 19,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-12",
          yungtestworkspace4: 13,
          yungtestworkspace5: 35,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-13",
          yungtestworkspace4: 50,
          yungtestworkspace5: 15,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-14",
          yungtestworkspace4: 32,
          yungtestworkspace5: 26,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-15",
          yungtestworkspace4: 23,
          yungtestworkspace5: 14,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-16",
          yungtestworkspace4: 50,
          yungtestworkspace5: 37,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-17",
          yungtestworkspace4: 24,
          yungtestworkspace5: 35,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-18",
          yungtestworkspace4: 38,
          yungtestworkspace5: 19,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-19",
          yungtestworkspace4: 27,
          yungtestworkspace5: 16,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-20",
          yungtestworkspace4: 27,
          yungtestworkspace5: 41,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-21",
          yungtestworkspace4: 18,
          yungtestworkspace5: 49,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-22",
          yungtestworkspace4: 35,
          yungtestworkspace5: 26,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-23",
          yungtestworkspace4: 25,
          yungtestworkspace5: 24,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-24",
          yungtestworkspace4: 46,
          yungtestworkspace5: 15,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-25",
          yungtestworkspace4: 40,
          yungtestworkspace5: 48,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-26",
          yungtestworkspace4: 47,
          yungtestworkspace5: 17,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-27",
          yungtestworkspace4: 47,
          yungtestworkspace5: 22,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-28",
          yungtestworkspace4: 42,
          yungtestworkspace5: 19,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-29",
          yungtestworkspace4: 44,
          yungtestworkspace5: 30,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-30",
          yungtestworkspace4: 36,
          yungtestworkspace5: 22,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-31",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2025-01-01",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2025-01-02",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2025-01-03",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2025-01-04",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2025-01-05",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2025-01-06",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
      ],
      engagementRate: [
        {
          date: "2024-12-08",
          yungtestworkspace4: 2.3516237402015676,
          yungtestworkspace5: 2.068045363575717,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-09",
          yungtestworkspace4: 2.3861967694566815,
          yungtestworkspace5: 2.5842329080798168,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-10",
          yungtestworkspace4: 2.4945770065075923,
          yungtestworkspace5: 2.3434991974317816,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-11",
          yungtestworkspace4: 2.700781805259417,
          yungtestworkspace5: 2.7332704995287465,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-12",
          yungtestworkspace4: 2.5391304347826087,
          yungtestworkspace5: 2.316244595429277,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-13",
          yungtestworkspace4: 2.5925925925925926,
          yungtestworkspace5: 1.8925518925518925,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-14",
          yungtestworkspace4: 2.150181938471717,
          yungtestworkspace5: 2.0733173076923075,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-15",
          yungtestworkspace4: 2.4587512131996117,
          yungtestworkspace5: 1.8628030751034892,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-16",
          yungtestworkspace4: 2.5883838383838382,
          yungtestworkspace5: 1.8255578093306288,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-17",
          yungtestworkspace4: 2.5608994378513428,
          yungtestworkspace5: 1.856082238720731,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-18",
          yungtestworkspace4: 1.9530057979859627,
          yungtestworkspace5: 2.2868435911914173,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-19",
          yungtestworkspace4: 2.121936640765093,
          yungtestworkspace5: 1.8070614400889629,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-20",
          yungtestworkspace4: 1.826215022091311,
          yungtestworkspace5: 2.184598580010923,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-21",
          yungtestworkspace4: 2.0930232558139537,
          yungtestworkspace5: 1.7103153393907,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-22",
          yungtestworkspace4: 2.026255707762557,
          yungtestworkspace5: 1.4488935721812435,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-23",
          yungtestworkspace4: 1.7504234895539243,
          yungtestworkspace5: 1.5568240788790866,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-24",
          yungtestworkspace4: 2.131782945736434,
          yungtestworkspace5: 2.088167053364269,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-25",
          yungtestworkspace4: 2.1909656478225585,
          yungtestworkspace5: 1.5419615773508595,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-26",
          yungtestworkspace4: 1.5159574468085106,
          yungtestworkspace5: 1.9563581640331076,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-27",
          yungtestworkspace4: 1.8803865238965787,
          yungtestworkspace5: 1.826258637709773,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-28",
          yungtestworkspace4: 1.810762560571283,
          yungtestworkspace5: 1.7228827954380004,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-29",
          yungtestworkspace4: 1.6808830908178627,
          yungtestworkspace5: 2.075381679389313,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-30",
          yungtestworkspace4: 0.4458756502353232,
          yungtestworkspace5: 0.5205868433506862,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-31",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2025-01-01",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2025-01-02",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2025-01-03",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2025-01-04",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2025-01-05",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2025-01-06",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
      ],
      "Retention Rate": [
        {
          date: "2024-12-08",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-09",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-10",
          yungtestworkspace4: 76.59574468085107,
          yungtestworkspace5: 65,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-11",
          yungtestworkspace4: 62.857142857142854,
          yungtestworkspace5: 78.125,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-12",
          yungtestworkspace4: 67.85714285714286,
          yungtestworkspace5: 77.41935483870968,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-13",
          yungtestworkspace4: 76,
          yungtestworkspace5: 63.26530612244898,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-14",
          yungtestworkspace4: 60.416666666666664,
          yungtestworkspace5: 65.71428571428571,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-15",
          yungtestworkspace4: 82,
          yungtestworkspace5: 73.91304347826086,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-16",
          yungtestworkspace4: 71.875,
          yungtestworkspace5: 65.38461538461539,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-17",
          yungtestworkspace4: 68.88888888888889,
          yungtestworkspace5: 62.5,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-18",
          yungtestworkspace4: 64,
          yungtestworkspace5: 75.67567567567568,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-19",
          yungtestworkspace4: 66.66666666666666,
          yungtestworkspace5: 62.857142857142854,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-20",
          yungtestworkspace4: 76.31578947368422,
          yungtestworkspace5: 76.19047619047619,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-21",
          yungtestworkspace4: 66.66666666666666,
          yungtestworkspace5: 61.53846153846154,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-22",
          yungtestworkspace4: 70.37037037037037,
          yungtestworkspace5: 65.85365853658537,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-23",
          yungtestworkspace4: 66.66666666666666,
          yungtestworkspace5: 73.46938775510205,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-24",
          yungtestworkspace4: 77.14285714285715,
          yungtestworkspace5: 71.42857142857143,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-25",
          yungtestworkspace4: 64,
          yungtestworkspace5: 73.52941176470588,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-26",
          yungtestworkspace4: 69.56521739130434,
          yungtestworkspace5: 80,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-27",
          yungtestworkspace4: 71.11111111111111,
          yungtestworkspace5: 66.66666666666666,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-28",
          yungtestworkspace4: 61.702127659574465,
          yungtestworkspace5: 64.70588235294117,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-29",
          yungtestworkspace4: 68.08510638297872,
          yungtestworkspace5: 65.11627906976744,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-30",
          yungtestworkspace4: 78,
          yungtestworkspace5: 68.42105263157895,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-31",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2025-01-01",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2025-01-02",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2025-01-03",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2025-01-04",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2025-01-05",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2025-01-06",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
      ],
    },
  },
  tableData: [
    {
      _id: "67765e47b05b20a142f104b0",
      entityName: "morphgranttrackingdashboardtest1231",
      activeWalletOnChain: "-",
      activeWalletOnWebsite: 1,
      activeWalletOnWebsiteGrowthRate: "-",
      transactionCount: "-",
      transactionCountGrowthRate: "-",
      newDiscordMember: "-",
      newDiscordMemberGrowthRate: "-",
      newTelegramMember: "-",
      newTelegramMemberGrowthRate: "-",
      sessionsFromFootprints: 2,
      sessionsFromFootprintsGrowthRate: "-",
      engagementRate: "-",
      engagementGrowthRate: "-",
      communityRetentionRate: "-",
      communityRetentionGrowthRate: "-",
      sessionCount: 2,
      sessionCountGrowthRate: "-",
    },
    {
      _id: "676a97ea052dad8c9febbe93",
      entityName: "yungtestworkspace5",
      activeWalletOnChain: 1087,
      activeWalletOnWebsite: 64,
      activeWalletOnWebsiteGrowthRate: -48.38709677419355,
      transactionCount: 2345,
      transactionCountGrowthRate: -55.54502369668246,
      newDiscordMember: 149,
      newDiscordMemberGrowthRate: "-",
      newTelegramMember: 173,
      newTelegramMemberGrowthRate: "-",
      sessionsFromFootprints: 73,
      sessionsFromFootprintsGrowthRate: -47.85714285714286,
      engagementRate: 0.8011628693124196,
      engagementGrowthRate: "-",
      communityRetentionRate: 68.98197614419084,
      communityRetentionGrowthRate: -0.3569959139781572,
      sessionCount: 73,
      sessionCountGrowthRate: -47.85714285714286,
    },
    {
      _id: "6705e4c1c36ea5e9fba25f57",
      entityName: "yungtestworkspace4",
      activeWalletOnChain: 1103,
      activeWalletOnWebsite: 63,
      activeWalletOnWebsiteGrowthRate: -49.6,
      transactionCount: 2389,
      transactionCountGrowthRate: -56.28545288197622,
      newDiscordMember: 193,
      newDiscordMemberGrowthRate: "-",
      newTelegramMember: 302,
      newTelegramMemberGrowthRate: "-",
      sessionsFromFootprints: 71,
      sessionsFromFootprintsGrowthRate: -49.645390070921984,
      engagementRate: 0.7838210835486039,
      engagementGrowthRate: "-",
      communityRetentionRate: 69.69271250899374,
      communityRetentionGrowthRate: -0.4401964426836229,
      sessionCount: 71,
      sessionCountGrowthRate: -49.645390070921984,
    },
    {
      _id: "67049db39b7e1c1327b3d52c",
      entityName: "yungtestworkspace3",
      activeWalletOnChain: 3045,
      activeWalletOnWebsite: 29,
      activeWalletOnWebsiteGrowthRate: -74.10714285714286,
      transactionCount: 4124,
      transactionCountGrowthRate: 1042.3822714681442,
      newDiscordMember: 0,
      newDiscordMemberGrowthRate: 0,
      newTelegramMember: 0,
      newTelegramMemberGrowthRate: 0,
      sessionsFromFootprints: 29,
      sessionsFromFootprintsGrowthRate: -93.22429906542055,
      engagementRate: 0,
      engagementGrowthRate: "-",
      communityRetentionRate: 0,
      communityRetentionGrowthRate: null,
      sessionCount: 29,
      sessionCountGrowthRate: -93.22429906542055,
    },
    {
      _id: "66cebfa17c822d33f26a474f",
      entityName: "ethan",
      activeWalletOnChain: "-",
      activeWalletOnWebsite: "-",
      activeWalletOnWebsiteGrowthRate: "-",
      transactionCount: "-",
      transactionCountGrowthRate: "-",
      newDiscordMember: "-",
      newDiscordMemberGrowthRate: "-",
      newTelegramMember: "-",
      newTelegramMemberGrowthRate: "-",
      sessionsFromFootprints: "-",
      sessionsFromFootprintsGrowthRate: "-",
      engagementRate: "-",
      engagementGrowthRate: "-",
      communityRetentionRate: "-",
      communityRetentionGrowthRate: "-",
      sessionCount: "-",
      sessionCountGrowthRate: "-",
    },
    {
      _id: "668f90902f860c7321aa4cd0",
      entityName: "testautoassign",
      activeWalletOnChain: "-",
      activeWalletOnWebsite: "-",
      activeWalletOnWebsiteGrowthRate: "-",
      transactionCount: "-",
      transactionCountGrowthRate: "-",
      newDiscordMember: "-",
      newDiscordMemberGrowthRate: "-",
      newTelegramMember: "-",
      newTelegramMemberGrowthRate: "-",
      sessionsFromFootprints: "-",
      sessionsFromFootprintsGrowthRate: "-",
      engagementRate: "-",
      engagementGrowthRate: "-",
      communityRetentionRate: "-",
      communityRetentionGrowthRate: "-",
      sessionCount: "-",
      sessionCountGrowthRate: "-",
    },
    {
      _id: "659e2421a68ca1205a0faafa",
      entityName: "jeff",
      activeWalletOnChain: 1100,
      activeWalletOnWebsite: 0,
      activeWalletOnWebsiteGrowthRate: -100,
      transactionCount: 1444,
      transactionCountGrowthRate: 652.0833333333333,
      newDiscordMember: "-",
      newDiscordMemberGrowthRate: "-",
      newTelegramMember: "-",
      newTelegramMemberGrowthRate: "-",
      sessionsFromFootprints: 0,
      sessionsFromFootprintsGrowthRate: -100,
      engagementRate: "-",
      engagementGrowthRate: "-",
      communityRetentionRate: "-",
      communityRetentionGrowthRate: "-",
      sessionCount: 0,
      sessionCountGrowthRate: -100,
    },
  ],
};

export default ecoscanMockData;
